import ivclass from '@invideoio/web-shared/Modules/IVClass';
import React from 'react';
import Content from './Content';
import { GuideCardProps } from './types';
import { BrowserType } from '@invideoio/web-shared/constants/common';

const Guide = (props: GuideCardProps) => {
  const {
    heading1,
    heading2,
    description,
    cardImage,
    bgImage,
    no = 1,
    platform,
    browser,
  } = props;

  const { defaultUrl, webpUrl } = bgImage[platform];
  const imageURL = browser === BrowserType.Safari ? defaultUrl : webpUrl;
  const styles = {
    '--guide-img-url': `url(${imageURL})`,
  } as React.CSSProperties;

  return (
    <div
      className={ivclass('iv-rounded-3xl', 'iv-overflow-hidden', 'iv-h-full')}
    >
      <div
        style={styles}
        className={ivclass(
          'iv-guide-img',
          'iv-h-full',
          'iv-bg-no-repeat iv-bg-cover',
        )}
      >
        <div
          className={ivclass(
            'sm:iv-p-25 md:iv-p-35 lg:iv-p-35 xl:iv-p-40',
            'iv-text-grey-0',
            'iv-h-full',
          )}
        >
          <Content
            index={no}
            heading={{
              heading1,
              heading2,
            }}
            description={description}
            image={cardImage}
            platform={platform}
            browser={browser}
          />
        </div>
      </div>
    </div>
  );
};

export default Guide;
